import 'babel-polyfill';

import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom';

import store from './store';
import { initUser } from './actions/auth-user';
import AccessControl from './services/access-control';

import App from './app';
import './index.css';

import history from './tools/history';

import { setApiFetcherStore } from './tools/api-fetcher';

import {
  initAnalytics,
  trackAnalyticsComponentWrapper as withAnalyticsTracker
} from './tools/google-analytics';

class Main extends Component {
  componentWillMount() {
    const splashScreenElement = document.getElementById('splashScreen');
    splashScreenElement.parentNode.removeChild(splashScreenElement);

    initAnalytics();

    AccessControl.init(store);
    setApiFetcherStore(store);

    store.dispatch(initUser());
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <Route path="/" component={withAnalyticsTracker(App)} />
        </Router>
      </Provider>
    );
  }
}

ReactDOM.render(<Main />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js